// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-tabview-nav-container {
  border-bottom: 1px solid var(--primary-border-color);
}

.p-tabview-nav {
  display: flex;
  padding: 0;
  width: min-content;
  list-style-type: none;
  gap: 24px;
  margin: 0;
}

.p-tabview-nav-content {
  padding: 0;
}

.p-tabview-title {
  font-size: 14px;
  font-weight: 400;
}

.p-tabview-nav {
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tab-view.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".p-tabview-nav-container {\n  border-bottom: 1px solid var(--primary-border-color);\n}\n\n.p-tabview-nav {\n  display: flex;\n  padding: 0;\n  width: min-content;\n  list-style-type: none;\n  gap: 24px;\n  margin: 0;\n}\n\n.p-tabview-nav-content {\n  padding: 0;\n}\n\n.p-tabview-title {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.p-tabview-nav {\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
